import React from "react";
import ApplicationPageProps from "common/models/ApplicationPageProps";
import { Redirect } from "react-router-dom";

export default function MarketingPage(props: ApplicationPageProps) {
  return <Redirect to="/applications/marketing/sale-information-update"/>;
}
